import { render, staticRenderFns } from "./SalesItemForm.vue?vue&type=template&id=129e8ab4&"
import script from "./SalesItemForm.vue?vue&type=script&lang=js&"
export * from "./SalesItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports